import { useMemo } from 'react'

import { useTable } from '@/ui/Table'
import { Log } from '@/types/logs'

import { reorderLinkedLogs } from '../../helpers/reorderLinkedLogs'
import { useUnfinishedLogsColumns } from './useUnfinishedLogsColumns'
import { useGetAllUnfinishedLogsForController } from '../../api/useGetAllUnfinishedLogsForController'

export const useUnfinishedLogsControllerTabTable = (actionCallback?: (log: Log) => void) => {
    const { data, isLoading: isDataLoading } = useGetAllUnfinishedLogsForController()

    const logs = useMemo(() => {
        if (!data) {
            return []
        }

        return reorderLinkedLogs(data)
    }, [data])

    const columns = useUnfinishedLogsColumns(isDataLoading, actionCallback)

    const table = useTable({
        data: logs,
        columns,
    })

    return {
        table,
        hasNoRows: !logs.length,
        columns,
        isLoading: isDataLoading,
    }
}
